import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import {
	Box,
	BoxProps,
	HStack,
	Icon,
	Popover,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	Text,
	useDisclosure
} from '@chakra-ui/react'

import inDevelopmentIcon from '@wwt/shared/assets/icons/outline/in-development.svg'

interface FeatureIsNotImplementedProps extends BoxProps {
	children: ReactNode
}

/**
 * @deprecated Use `UnderDevelopment` from `@/shared/ui/under-development` instead
 */
export const FeatureIsNotImplemented = ({
	children,
	...boxProps
}: FeatureIsNotImplementedProps) => {
	const { t } = useTranslation('tooltips')
	const { isOpen, onOpen, onClose } = useDisclosure()

	return (
		<Popover
			variant="default"
			trigger="hover"
			openDelay={0}
			closeDelay={0}
			isLazy
			onOpen={onOpen}
			onClose={onClose}
		>
			<PopoverTrigger>
				<Box {...boxProps}>{children}</Box>
			</PopoverTrigger>
			<PopoverContent
				maxW="20.75rem"
				w="full"
				borderColor="gray.200"
				boxShadow="0rem .125rem .75rem 0rem #00000024"
				border={isOpen ? '.0625rem solid' : 'none'}
				pointerEvents="none"
			>
				<PopoverBody p=".75rem 1rem">
					<HStack gap="1rem">
						<Icon
							as={inDevelopmentIcon}
							w="1.5rem"
							h="1.5rem"
						/>
						<Text textStyle={{ base: 'body-text-7', xl: 'body-text-6' }}>
							{t('featureIsNotImplementedYet')}
						</Text>
					</HStack>
				</PopoverBody>
			</PopoverContent>
		</Popover>
	)
}
